var _style, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBombExploded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 581.5 532.9",
    style: {
      enableBackground: "new 0 0 581.5 532.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFB41D;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "318.8,5 328,184.6 425.4,108.5 385.3,239 543.7,209 425.4,313.1 549.8,326.3 434.3,394.3 574.2,527.8  387.9,430.3 394.5,494.8 312.7,436.9 294.5,482.1 244.7,436.9 183.3,523.2 179.7,405 16.8,425.8 143.7,349.6 66.5,322.2  135.6,286.2 7.2,173.5 178.2,238.5 177.2,125.3 244.7,199.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBombExploded);
export default __webpack_public_path__ + "static/media/bomb_exploded.ae8176a49fc17e2dce4abd8b0ef0e632.svg";
export { ForwardRef as ReactComponent };